import React, { useState, useEffect } from 'react';
import { getRequests, removeApplication } from './activity';
import { Container, Row, Col } from 'react-bootstrap';

import UniversalModall, { useModal } from '../../../components/AlertModal/UniversalModal';

import statuses from './data/statuses';

import ApplicationCard from './ApplicationCard';
import './ApplicationsPage.css';

const ApplicationsPage = ({ onEdit, type }) => {
  // Пример данных заявок

  const [data, setData] = useState({
        active: [],
        inkg:[],
        rm:[],
        raw:{}
    });
  
  const {
      modalProps,
      alert,
      confirm,
      prompt,
      success,
      error,
      warning,
      Modal
  } = useModal();

  const upd_data = async ()=>{
            const res = await getRequests(statuses[type]);
            if(res && res.active) setData(res);
        };
  

  useEffect(()=>{
        if(type && statuses[type]) upd_data();
   }, [type]);

  const setEdit = (id)=>{
    const info = data.raw[id];
    onEdit({info});
  }

  const removeCard = async (id)=>{

    const result = await confirm('Після видаленння поновити заявку буде неможливо. Ви дійсно бажаєте видали заявку?');

    if (result.button === 'Підтвердити'){
      const ret = await removeApplication(id);
      if(ret) await success('Заявка успішно видалена.')
      upd_data();
    }

  }

  if (data.active.length === 0) {
    return (
      <div className="cabinet-children-list">
        <Container fluid>
          <Row>
            <Col md={12}>
              <div className="no-children-message">
                <h3>Заявки цього розділу відсутні</h3>
                <p>Поки що немає заявок для цього розділу.</p>
                {false && <button className="btn btn-primary">Додати дитину</button>}
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }

  return (
    <div className="applications-page">
      <div className="content-wrapper">
        {data.active.map(application => (
          <ApplicationCard 
            key={application.id} 
            application={application}
            onEdit={()=>setEdit(application.id)}
            onRemove={()=>removeCard(application.id)}
            onUpdate={upd_data} 
          />
        ))}
      </div>
      <Modal />
    </div>
  );
};

export default ApplicationsPage;